import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    billing: {
      resume: null
    }
  },
  mutations: {
    SET_BILLING_RESUME (store, data) {
      store.billing.resume = data
    }
  },
  getters: {
    getBillingResume: (store, getters) => {
      return store.billing.resume
    }
  },
  actions: {
    /*
    selectBillingResume
    */
    selectBillingResume ({commit, dispatch, getters, state}, id) {
      return dispatch('getBillingResume')
      .then(response => {
        commit('SET_BILLING_RESUME', response)
        return response
      })
    },
    // billing
    getBillingResume ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing`)
      .then(response => {
        return response.data
      })
    },
    getBillingPlans ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/plans`)
      .then(response => {
        return response.data
      })
    },
    // customer
    getBillingCustomer ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/customer`)
      .then(response => {
        return response.data
      })
    },
    createBillingCustomer ({commit, dispatch, getters, state}, data) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/billing/customer`, data)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    updateBillingCustomer ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/billing/customer`, data)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    // subscription
    getBillingSubscription ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/subscription`)
      .then(response => {
        return response.data
      })
    },
    createBillingSubscription ({commit, dispatch, getters, state}, data) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/billing/subscription`, data)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    getBillingSimulateChangePlan ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/subscription/simulate-change-plan/${id}`)
      .then(response => {
        return response.data
      })
    },
    updateBillingChangePlan ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/billing/subscription/change-plan`, data)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    billingSubscriptionActivate ({commit, dispatch, getters, state}, data) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/billing/subscription/activate`)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    // invoices
    getBillingInvoices ({commit, dispatch, getters, state}, params) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/invoices`, { params: params })
      .then(response => {
        return response.data
      })
    },
    // Paymethods
    getBillingPaymethods ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/paymethods`)
      .then(response => {
        return response.data
      })
    },
    getBillingPaymethod ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/billing/paymethods/${id}`)
      .then(response => {
        return response.data
      })
    },
    createBillingPaymethod ({commit, dispatch, getters, state}, data) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/billing/paymethods`, data)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    billingPaymethodsSetAsDefault ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/billing/paymethods/${id}/set-as-default`)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    },
    deleteBillingPaymethod ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/billing/paymethods/${id}`)
      .then(response => {
        return dispatch('selectBillingResume').then(() => {
          return response.data
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Billing.js